(function(){

    angular.module('tmx-app').controller('branchLevelReportCtrl', ['$scope','$state','$mdDialog', 'tmxUtility','$mdSidenav',
        'TmxDialogService','ServerExceptionService','resolvedData',BranchLevelReportCtrl]);

    function BranchLevelReportCtrl($scope, $state,$mdDialog,tmxUtility,$mdSidenav, TmxDialogService,ServerExceptionService,resolvedData){
        var branchLevelReportVM=this;
        branchLevelReportVM.loading=false;
        branchLevelReportVM.TimeFrames = resolvedData.TimeFrames.data;
    }

})();